import { useMutation } from '@tanstack/react-query';
import api from '../../http';

export interface TrackCheckoutStartPayload {
	step: 'cadastro' | 'plano' | 'pagamento';
	planId?: string;
}

export const useTrackCheckoutStart = () => {
	return useMutation({
		mutationFn: async (payload: TrackCheckoutStartPayload) => {
			await api.post('/user/checkout/track-start', payload);
		},
		onError: (error) => console.error('Erro ao registrar início de checkout:', error),
	});
};
